import { render, staticRenderFns } from "./wBanner.vue?vue&type=template&id=cef3ac90&scoped=true"
import script from "./wBanner.vue?vue&type=script&lang=js"
export * from "./wBanner.vue?vue&type=script&lang=js"
import style0 from "./wBanner.vue?vue&type=style&index=0&id=cef3ac90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef3ac90",
  null
  
)

export default component.exports